import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { CheckboxField } from "@/shared/ui/core";

/**
 * Un enlace a un documento legal. Los dos del registro llevaban la MISMA
 * cadena de clases copiada; la tercera copia (la de la baja de cuenta) iba
 * a divergir por una letra y nadie lo notaría.
 */
function LegalLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link
      to={to}
      className="font-medium text-ds-violet-pop underline underline-offset-2"
    >
      {children}
    </Link>
  );
}

export interface TermsCheckboxProps {
  /** Por defecto `"acceptedTerms"`, como en el contrato. */
  name?: string;
  /** Clase del contenedor del campo — para el `col-span` de una rejilla. */
  fieldClassName?: string;
}

/**
 * La casilla de aceptar términos y privacidad.
 *
 * Vive aquí porque su texto es una decisión legal, no de pantalla: el día
 * que cambie la redacción o se añada un tercer documento, cambia en un
 * sitio y no en cada formulario que pida consentimiento.
 *
 * El enlace DENTRO del label funciona: el estándar dice que activar
 * contenido interactivo dentro de un `<label>` no activa el control, así
 * que tocar "términos y condiciones" navega y tocar el resto marca la
 * casilla.
 */
export function TermsCheckbox({
  name = "acceptedTerms",
  fieldClassName,
}: TermsCheckboxProps) {
  return (
    <CheckboxField
      name={name}
      fieldClassName={fieldClassName}
      label={
        <>
          Acepto los <LegalLink to="/terminos">términos y condiciones</LegalLink> y
          el <LegalLink to="/privacidad">aviso de privacidad</LegalLink>.
        </>
      }
    />
  );
}
